/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransitionDto
 */
export interface TransitionDto {
    /**
     * 
     * @type {string}
     * @memberof TransitionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionDto
     */
    fromState?: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionDto
     */
    toState?: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionDto
     */
    transitionReason?: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionDto
     */
    actorId?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransitionDto
     */
    transitionedAt?: Date;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TransitionDto
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the TransitionDto interface.
 */
export function instanceOfTransitionDto(value: object): value is TransitionDto {
    return true;
}

export function TransitionDtoFromJSON(json: any): TransitionDto {
    return TransitionDtoFromJSONTyped(json, false);
}

export function TransitionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransitionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fromState': json['fromState'] == null ? undefined : json['fromState'],
        'toState': json['toState'] == null ? undefined : json['toState'],
        'transitionReason': json['transitionReason'] == null ? undefined : json['transitionReason'],
        'actorId': json['actorId'] == null ? undefined : json['actorId'],
        'transitionedAt': json['transitionedAt'] == null ? undefined : (new Date(json['transitionedAt'])),
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function TransitionDtoToJSON(json: any): TransitionDto {
    return TransitionDtoToJSONTyped(json, false);
}

export function TransitionDtoToJSONTyped(value?: TransitionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fromState': value['fromState'],
        'toState': value['toState'],
        'transitionReason': value['transitionReason'],
        'actorId': value['actorId'],
        'transitionedAt': value['transitionedAt'] == null ? undefined : ((value['transitionedAt']).toISOString()),
        'metadata': value['metadata'],
    };
}

